import React, { useEffect, useState } from "react";
import { useAxiosInstance } from "../../../common/hooks/useAxiosInstance";
import { FormTab } from "react-admin";
import {
  NotificationApiFactory,
  NotificationTypeDto,
  NotificationSubject,
} from "../../../common/data/service-proxies";
import memoizeOne from "memoize-one";
import { AxiosInstance } from "axios";
import { EventTypesSubjectSelector } from "./EventTypesSubjectSelector";
import { from, IGrouping } from "manipula";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";

interface Props {}

const getEventTypesFromApi = async (
  axiosInstance: AxiosInstance
): Promise<IGrouping<NotificationSubject, NotificationTypeDto>[]> => {
  if (!axiosInstance) {
    return [];
  }

  try {
    const permissionsFromApi = (
      await NotificationApiFactory(
        undefined,
        axiosInstance.defaults.baseURL,
        axiosInstance
      ).apiAppNotificationNotificationtypesGet()
    ).data;

    if (!permissionsFromApi) {
      return [];
    }

    return from(permissionsFromApi)
      .groupBy((x) => x.subject!)
      .toArray();
  } catch {
    return [];
  }
};

const memoizedNotificationTypes = memoizeOne(
  async (axiosInstance: AxiosInstance) =>
    await getEventTypesFromApi(axiosInstance)
);

export const NotificationSubscriptionEventTypesTab = (props: Props) => {
  const axiosInstance = useAxiosInstance();
  const [groupedNotificationTypes, setNotificationTypes] = useState<
    IGrouping<NotificationSubject, NotificationTypeDto>[]
  >();

  useEffect(() => {
    if (!axiosInstance) {
      return;
    }

    if (groupedNotificationTypes) {
      return;
    }

    memoizedNotificationTypes(axiosInstance)
      .then((data) => setNotificationTypes(data))
      .catch((e) => console.error(e));
  }, [axiosInstance, groupedNotificationTypes]);

  return (
    <FormTab {...props} label="resources.admin-notifications.labels.events">
      <ProtectedElement source="eventPreferences">
        <>
          {groupedNotificationTypes &&
            groupedNotificationTypes.map((notificationTypes) => (
              <EventTypesSubjectSelector
                key={notificationTypes.key}
                subject={notificationTypes.key}
                eventTypes={notificationTypes.toArray()}
              />
            ))}
        </>
      </ProtectedElement>
    </FormTab>
  );
};
